import React, {Fragment ,useState, useEffect} from 'react'
import AddOrEditOperator from "./AddOrEditOperatorForm";
import {connect} from 'react-redux' ;
import {Link, useParams} from 'react-router-dom' ;
import {getOperator} from "./actions";
import _ from 'lodash' ;
import {addOperator , editOperator} from "./actions";
import {withRouter} from 'react-router-dom' ;
import {reset} from 'redux-form' ;

const AddOperator = (props) => {

    const {id} = useParams() ;
    const {operatorInfo, postOperatorInfoResult} = props ;
    const [bookInitialValues , setBookInitialValues] = useState({}) ;
    const [renderForm , setRenderForm] = useState(false) ;
    const [loading , setLoading] = useState(false) ;
    const [postOperatorInfoResultMessage , setPostBookResultMessage] = useState(null) ;

    const onFormSubmit = (values) => {
        setLoading(true) ;
        let data = values;
        if (id === 'new') {
            props.addOperator(data) ;
        }
        else {
            data = {...data , id : Number(id)} ;
            props.editOperator(Number(id), data) ;
        }

    };

    const bookFormInitialValues = () => {
        if (id === 'new') {
            return {} ;
        }
        return operatorInfo;
    };

    useEffect(() => {
        if (id !== 'new') {
            setRenderForm(false)
            props.getOperator(id) ;
        }
        else {
            props.reset("AddOrEditOperator") ;
        }
    } ,[]);

    useEffect(() => {
        if (!_.isEmpty(operatorInfo)) {
            setBookInitialValues(bookFormInitialValues()) ;
            setRenderForm(true) ;
        }
        else {
            setBookInitialValues({}) ;
        }
        if (id === 'new') {
            setRenderForm(true) ;
        }
    } , [operatorInfo]);

    useEffect(() => {
        if (!_.isEmpty(postOperatorInfoResult)) {
            setLoading(false) ;
            if (postOperatorInfoResult.isSuccess) {
                if (id === 'new') {
                    props.history.push('/operators') ;
                }
                else {
                    setPostBookResultMessage({success : true , message : postOperatorInfoResult.message}) ;
                }
            }
            else{
                setPostBookResultMessage({success : false , message : postOperatorInfoResult.message}) ;
            }
        }
    } ,[postOperatorInfoResult]);

    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle ">
                    <div className="longTitle">
                        <Link to="/operators"><span className="back"><span
                            className="icon icon-arrow-right font-size_14"></span> بازگشت </span></Link>
                        <span className="separator"></span>
                        <span className=" font-size_24 boldFont middleContext">اوپراتورها</span>
                        <span className="icon icon-arrow-left middleContext verticalSpace"></span>
                        {id === 'new' ?
                            <span className="customerName font-size_14 mediumWFont">جدید</span> :
                            <Fragment>
                                <span className="customerName font-size_14 mediumWFont">{operatorInfo? operatorInfo.fullName : null}</span>
                                <span className="separator"></span>
                                <span
                                    className="costumerCreationDate font-size_14 lightFont">تاریخ ایجاد: {operatorInfo? operatorInfo.jalaliCreateDate : null}</span>
                            </Fragment>
                        }
                    </div>
                </div>
            </div>
            <span className="lineSeparator"></span>
            {renderForm ? <AddOrEditOperator onSubmit={onFormSubmit} initialValues={bookInitialValues} isAdd={id === 'new'} loading={loading}/> : null}
        </Fragment>
    );
};

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    return {
        operatorInfo : id === 'new' ? null : state.operatorsInfo[id],
        postOperatorInfoResult : state.postOperatorInfoResult
    };
};

export default withRouter(connect(mapStateToProps , {getOperator , editOperator , addOperator, reset})(AddOperator))